import { FC, ReactNode } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

import "./Modal.scss";
import Loader from "../loader";

type ModalProps = {
  title: string;
  sideTitle?: string;
  icon?: ReactNode;
  show: boolean;
  variant?: "default" | "alt";
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  takeover?: boolean;
  footerElement?: ReactNode;
  children: ReactNode;
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
  closeButtonClassName?: string;
  focusTrapOptions?: Record<string, any>;
  onClose?: () => void;
};
const Modal: FC<ModalProps> = ({
  title,
  sideTitle,
  icon,
  show,
  variant,
  footerElement,
  children,
  size = "sm",
  takeover = false,
  className = "",
  headerClassName = "",
  bodyClassName = "",
  footerClassName = "",
  closeButtonClassName = "",
  focusTrapOptions,
  onClose
}: ModalProps) => {
  const styles = takeover
    ? {
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%"
          }
        }
      }
    : {
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "700px"
          }
        }
      };
  return (
    <Dialog
      className={`modal ${className}`}
      open={show}
      maxWidth={size}
      data-test-id="motif-modal-overlay"
      fullScreen={takeover}
      onClose={onClose}
      sx={styles}
    >
      <DialogTitle className={headerClassName}>
        {icon && icon}
        {title}
        {sideTitle && <span className="side-title">{sideTitle}</span>}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500]
        })}
      >
        <CloseIcon />
      </IconButton>
      {!children && <Loader show={!children} />}
      <DialogContent className={bodyClassName}>{children}</DialogContent>
      {footerElement && (
        <DialogActions className={footerClassName}>
          {footerElement}
        </DialogActions>
      )}
    </Dialog>
  );
};
export default Modal;
